export function init() {
    let inputs = document.querySelectorAll('input[type="file"]');
    Array.prototype.forEach.call( inputs, function( input )
    {
        let label	 = input.nextElementSibling;

        input.addEventListener('change', function( e )
        {
            let fileName ='';
            if( this.files && this.files.length > 1 )
                fileName = ( this.getAttribute('data-multiple-caption') ||'').replace('{count}', this.files.length );
            else
                fileName = e.target.value.split('\\').pop();

            if( fileName ) {
                label.querySelector('span.file').innerHTML = fileName;
                label.querySelector('span.file').className += ' show';
            } else {
                label.querySelector('span.file').innerHTML = '';
                label.querySelector('span.file').className = label.querySelector('span.file').className.replace('show', '');
            }
        });
    });
}
